import { render, staticRenderFns } from "./CCMDiagnosis.vue?vue&type=template&id=0021d848"
import script from "./CCMDiagnosis.vue?vue&type=script&lang=js"
export * from "./CCMDiagnosis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports